import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  VStack,
  Box,
  Text,
  Button,
} from '@chakra-ui/react';

import type { APISignerRole } from 'types/api.types';
import { ROLE_COLORS, ROLE_LABELS } from '../stepConstants';

export interface Signer {
  role: APISignerRole | string;
  email: string;
  name?: string;
}

interface ConfirmSigningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  signers: Signer[];
  isLoading: boolean;
}

const ConfirmSigningModal = ({
  isOpen,
  onClose,
  onConfirm,
  signers,
  isLoading,
}: ConfirmSigningModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Signing Request</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="4">
            The signing request will be sent to the following email addresses:
          </Text>
          <VStack align="stretch" spacing="3">
            {signers.map((signer, index) => {
              const colors = ROLE_COLORS[signer.role] || ROLE_COLORS.applicant;
              return (
                <Box
                  key={`${signer.role}-${index}`}
                  p="3"
                  borderRadius="md"
                  bg={colors.bg}
                  borderLeft="4px solid"
                  borderLeftColor={colors.border}
                >
                  <Text
                    fontSize="sm"
                    fontWeight="semibold"
                    color={colors.title}
                    mb="1"
                  >
                    {ROLE_LABELS[signer.role] || signer.role}:
                  </Text>
                  <Text fontSize="sm" color={colors.text}>
                    {signer.email}
                    {signer.name && ` (${signer.name})`}
                  </Text>
                </Box>
              );
            })}
          </VStack>
          <Text mt="4" fontSize="sm" color="gray.600">
            Do you want to proceed with sending the documents for signing?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr="3" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="brand"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Send for Signing
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmSigningModal;
